import type { SuppliersListParams } from '../../services/suppliers/suppliers.types';

export const supplierQueryKeys = {
  all: ['suppliers'] as const,
  list: (params: SuppliersListParams) => ['suppliers', 'list', params] as const,
};
